import { Routes } from "@angular/router";
import { BaseComponent } from "./views/layout/base/base.component";
import { ErrorPageComponent } from "./views/pages/error-page/error-page.component";
import { ComingSoonComponent } from "./views/pages/coming-soon/coming-soon.component";
import { AuthGuard } from "./core/guard/auth.guard";

export const routes: Routes = [
    {
        path: "auth",
        loadChildren: () => import("./views/pages/auth/auth.routes").then((m) => m.AUTH_ROUTES),
    },
    {
        path: "",
        component: BaseComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: "dashboard",
                loadChildren: () => import("./views/pages/dashboard/dashboard.routes").then((m) => m.DASHBOARD_ROUTES),
            },
            {
                path: "agent",
                loadChildren: () => import("./views/pages/agent/agent.routes").then((m) => m.AGENT_ROUTES),
            },
            {
                path: "my-contracting",
                loadChildren: () => import("./views/pages/my-contracting/my-contracting.routes").then((m) => m.MY_CONTRACTING_ROUTES),
            },
            {
                path: "user",
                loadChildren: () => import("./views/pages/user/user.routes").then((m) => m.USER_ROUTES),
            },
            {
                path: "market",
                loadChildren: () => import("./views/pages/market/market.routes").then((m) => m.MARKET_ROUTES),
            },
            {
                path: "document-type",
                loadChildren: () => import("./views/pages/document-type/document-type.routes").then((m) => m.DOCUMENT_TYPE_ROUTES),
            },
            {
                path: "permission",
                loadChildren: () => import("./views/pages/permission/permission.routes").then((m) => m.PERMISSION_ROUTES),
            },
            {
                path: "carrier",
                loadChildren: () => import("./views/pages/carrier/carrier.routes").then((m) => m.CARRIER_ROUTES),
            },
            {
                path: "coming-soon",
                loadChildren: () => import("./views/pages/coming-soon/coming-soon.routes").then((m) => m.COMING_SOON_ROUTES),
            },
            {
                path: "organization",
                loadChildren: () => import("./views/pages/organization/organization.routes").then((m) => m.ORGANIZATION_ROUTES),
            },
            {
                path: "my-organization",
                loadChildren: () => import("./views/pages/my-organization/my-organization.routes").then((m) => m.MY_ORGANIZATION_ROUTES),
            },
            {
                path: "application",
                loadChildren: () => import("./views/pages/application/application.routes").then((m) => m.APPLICATION_ROUTES),
            },
            {
                path: "gamification",
                loadChildren: () => import("./views/pages/gamification/gamification.routes").then((m) => m.GAMIFICATION_ROUTES),
            },
            { path: "", redirectTo: "dashboard", pathMatch: "full" },
        ],
    },

    {
        path: "error",
        component: ErrorPageComponent,
        data: {
            type: 404,
            title: "Page Not Found",
            desc: "Oopps!! The page you were looking for doesn't exist.",
        },
    },
    {
        path: "error/:type",
        component: ErrorPageComponent,
    },
    { path: "**", redirectTo: "error", pathMatch: "full" },
] as const;